import React from 'react';
import _ from 'lodash';
import OrganizationUnitBasicInfoComponent from './organization-unit-basicInfo.component';
import OrganizationUnitAddressComponent from './organization-unit-address.component';
import OrganizationUnitBrandInfoComponent from './organization-unit-brandInfo.component';
import OrganizationUnitMediaComponent from './organization-unit-media.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';



function OrganizationUnitComponent ({ handleFormSubmit,back,getIsFavRecordDeletable, onFormFavItemChange, deleteselectedFavIcon, changeFavImage, logoFiles, onFormLogoItemChange, getIsLogoRecordDeletable, faviconSize, changeLogoImage, logoBackground, deleteselectedLogo, onFormItemBrandChange, getIsBrandRecordDeletable, deleteSelectedBrands, brandMappings, socialProfileType, onFormSocialProfileItemChange, getIsSocialProfilesRecordDeletable, deleteSelectedSocialProfiles, socialProfiles, onFormItemChange, handleOpen, handleClose, fileTypes, deleteSelectedMedia, changeImage, mediaFiles,id,handleInnerbasicFormChange, selectedAddress, timeZones, currencyRoundingType, currencyCodeType, selectedOrganizationUnit, onInnerFormChange }: any) {
  
  const tabItems=[
    {
        id:1,
        title:'Basic Information',
        component:<OrganizationUnitBasicInfoComponent
        onInnerFormChange={onInnerFormChange}
        selectedOrganizationUnit={selectedOrganizationUnit}
        currencyCodeType={currencyCodeType}
        currencyRoundingType={currencyRoundingType}
        timeZones={timeZones}
    />,
    isVisible:true,
    },
    {
        id:2,
        title:'Address',
        component: <OrganizationUnitAddressComponent
        selectedAddress={selectedAddress}
        onInnerFormChange={onInnerFormChange}
        handleInnerbasicFormChange={handleInnerbasicFormChange}
        selectedOrganizationUnit={selectedOrganizationUnit}
   />,
        isVisible:true,
    },
    {
        id:3,
        title:'Media',
        component:<OrganizationUnitMediaComponent
        socialProfileType={socialProfileType} 
        onFormSocialProfileItemChange={onFormSocialProfileItemChange} 
        getIsSocialProfilesRecordDeletable={getIsSocialProfilesRecordDeletable}  
        deleteSelectedSocialProfiles={deleteSelectedSocialProfiles}
        socialProfiles={socialProfiles} 
        changeImage={changeImage}
        mediaFiles={mediaFiles}
        fileTypes={fileTypes}
        onFormItemChange={onFormItemChange}
        handleOpen={handleOpen}
        deleteSelectedMedia={deleteSelectedMedia}
     
        />,
        isVisible:id > 0 ? true : false,
    },
    {
        id:4,
        title:'Brand Mapping',
        component:<OrganizationUnitBrandInfoComponent
        changeImage={changeImage}
        deleteSelectedBrands={deleteSelectedBrands}
        getIsBrandRecordDeletable={getIsBrandRecordDeletable}
        handleClose={handleClose}
        handleOpen={handleOpen}
        onFormItemBrandChange={onFormItemBrandChange}
        logoFiles={logoFiles} 
        changeFavImage={changeFavImage}
        deleteselectedFavIcon={deleteselectedFavIcon}
        onFormFavItemChange={onFormFavItemChange}
        getIsFavRecordDeletable={getIsFavRecordDeletable}
        onFormLogoItemChange={onFormLogoItemChange} 
        getIsLogoRecordDeletable={getIsLogoRecordDeletable} 
        faviconSize={faviconSize} 
        changeLogoImage={changeLogoImage} 
        logoBackground={logoBackground}
        deleteselectedLogo={deleteselectedLogo}
        brandMappings={brandMappings}
        />,
        isVisible:id > 0 ? true : false,
    },
  ]
  return (
 
   <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
       
     
       <TabContainer tabItems={tabItems} />
    
       <div className='flex w-full justify-end items-end'>
         <button
               onClick={back}
               type='button'
               className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              >
               Back
              </button>
              <button
             className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
               onClick={handleFormSubmit}
             
               type="submit"
           >
             Save
           </button>
         </div>
        </div>
  );
}
export default OrganizationUnitComponent;
